
import * as yup from 'yup';

export const newMotivoProspecteoCorporativoSchema = yup.object({
  id_prospecto_corporativo: yup.string().required('Campo Obligatorio'),
  motivo_rechazo: yup.string().required('El motivo de rechazo es requerido'),
  razon_social: yup.string().required('Campo Obligatorio'),
  identificacion: yup.string().required('Campo Obligatorio'),
});